import fetch from '../../api/fetch'

/**
 *  Action to fetch existing locations
 *
 *  @param  {integer} quoteID [Quote ID]
 *  @param  {string} URL [/api/v1/quotes/:quote_id/locations]
 *  @method GET
 */
export function fetchLocations (quoteID: number) {
    return {
        type    : 'GET_LOCATIONS',
        payload : fetch(`/quotes/${quoteID}/locations`, { method: 'GET' }),
    }
}

/**
 *  Action to add new risk location
 *
 *  @param  {number} quoteID [Quote ID]
 *  @param  {object} address [object with the address details added on the form]
 *  @param  {string} URL [/api/v1/quotes/:quote_id/locations]
 *  @method POST
 */
export function addLocations (quoteID: number, address: object) {
    return {
        type    : 'ADD_LOCATIONS',
        payload : fetch(`/quotes/${quoteID}/locations`, { method: 'POST', body: address }),
    }
}

/**
 *  Action to add new risk location
 *
 *  @param  {number} quoteID [Quote ID]
 *  @param  {object} address [object with the address details added on the form]
 *  @param  {string} URL [/api/v1/quotes/:quote_id/locations]
 *  @method POST
 */
export function addLocationsRenewals (quoteID: number, address: object) {
    return {
        type    : 'ADD_LOCATIONS',
        payload : fetch(`/renewal/${quoteID}/locations`, { method: 'POST', body: address }),
    }
}

/**
 *  Action to add security check
 *
 *  @param  {number} quoteID [Quote ID]
 *  @param  {number} addressID [Address ID]
 *  @param  {object} body [object with the security details added on the form]
 *  @param  {string} URL [/api/v1/quotes/:quote_id/locations/:address_id]
 *  @method POST
 */
export function addLocationsSecurity (quoteID: number, addressID: number, body: object) {
    return {
        type    : 'ADD_LOCATIONS_SECURITY',
        payload : fetch(`/quotes/${quoteID}/locations/${addressID}`, { method: 'PATCH', body: body }),
    }
}

/**
 *  Action to delete location
 *
 *  @param  {number} quoteID [Quote ID]
 *  @param  {number} addressID [Address ID]
 *  @param  {string} URL [/api/v1/quotes/:quote_id/locations/:address_id]
 *  @method DELETE
 */
export function deleteLocation (quoteID: number, addressID: number) {
    return {
        type    : 'DEL_LOCATION',
        payload : {},
        quoteId : quoteID,
        addressId : addressID,
    }
}

/**
 *  Set step02 as submited
 *
 *  @param  {number} quoteID [Quote ID]
 *  @method POST
 */
export function submitStep02 (quoteID: number) {
    return {
        type    : 'SUBMIT_STEP02',
        payload : fetch(`/quotes/step02`, { method: 'POST', body: { 'quoteId': quoteID } }),
        quoteId: quoteID,
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/quote/step02.ts